import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import HoldingImage from "../holding-image/holding-image.component";
import LazyImage from "../lazy-image/lazy-image.component";
const Image = ({ i18n ={
    noImage: "Image Unavailable"
} , isLazy , className ="" , onError , ...props })=>{
    const [hasError, updateErrorState] = useState(false);
    const updateError = ()=>{
        updateErrorState(true);
    };
    return !props.src || hasError ? /*#__PURE__*/ _jsx(HoldingImage, {
        className: className,
        text: i18n.noImage
    }) : isLazy ? /*#__PURE__*/ _jsx(LazyImage, {
        ...props,
        className: className,
        onError: onError || updateError
    }) : /*#__PURE__*/ _jsx("img", {
        className: className,
        alt: props.alt || undefined,
        role: !props.alt ? "presentation" : undefined,
        src: props.src || "",
        onError: onError || updateError,
        width: props.width || undefined,
        height: props.height || undefined
    });
};
export default Image;
